import React from 'react';
import styled from 'styled-components';
import '../styles/globals.css';
import AIActionPlanDatabase from '../components/AIActionPlanDatabase';
import { Link } from 'react-router-dom';

const HomeContainer = styled.div`
  max-width: 100%;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #f8f9fa;
`;

const PageWrapper = styled.div`
  width: 100%;
  max-width: var(--container-width);
  margin: 0 auto;
  padding: 0 24px;
  
  @media (max-width: 768px) {
    padding: 0 16px;
  }
`;

const ContentColumn = styled.div`
  width: 100%;
  padding: 0.5rem 0;
  color: #333;
  
  @media (max-width: 768px) {
    padding: 0.25rem 0;
    margin-bottom: 0;
  }
  
  a {
    color: #ae7cef;
    text-decoration: none;
    
    &:hover {
      color: #9a64dc;
    }
  }
`;

const TitleSection = styled.div`
  width: 100%;
  padding: 2rem 0 0 0;
  margin: 0 0 12px 0;
  
  @media (max-width: 768px) {
    padding: 1.5rem 0 0 0;
  }
  
  p {
    color: #6b7280
  }
  
  a {
    color: #ae7cef;
    text-decoration: none;
    
    &:hover {
      color: #9a64dc;
    }
  }
`;

const Title = styled.h1`
  font-family: var(--font-soehne);
  font-weight: 600;
  color: #373737;
  font-size: 3.5rem;
  margin: 0 0 0 0;
  letter-spacing: 2px;
  word-spacing: 12px;
  text-transform: uppercase;
  text-align: left;
  
  @media (max-width: 768px) {
    font-size: 1.5rem;
    margin-bottom: 0.75rem;
    letter-spacing: 2px;
    word-spacing: 8px;
  }
`;

const DatabaseWrapper = styled.div`
  width: 100%;
  max-width: var(--container-width);
  margin: 0 auto;
  padding: 0 24px;
  
  @media (max-width: 768px) {
    padding: 0 16px;
  }
`;

const IntroText = styled.p`
  font-size: 1rem;
  line-height: 1.6;
  margin-bottom: 2rem;
  text-align: left;
  
  @media (max-width: 768px) {
    font-size: 0.9rem;
    margin-bottom: 1.5rem;
  }
`;

function Home() {
  
  return (
    <HomeContainer>
      <PageWrapper>
        <TitleSection>
          <Title>AI ACTION PLAN DATABASE</Title>
          <p><i>A project by the <a href="https://www.ifp.org" target="_blank" rel="noopener noreferrer">Institute for Progress</a></i></p>
        </TitleSection>
        
        <ContentColumn>
          <IntroText>
            In January 2025, President Trump tasked the Office of Science and Technology Policy 
            with creating an AI Action Plan to promote American AI Leadership. The government <a href="https://www.federalregister.gov/documents/2025/02/06/2025-02305/request-for-information-on-the-development-of-an-artificial-intelligence-ai-action-plan" target="_blank" rel="noopener noreferrer">
            requested input from the public</a>, and received 10,068 submissions. 
            The database below summarizes specific recommendations from these submissions. <Link to="/methodology">Reach out to us</Link> if your submission isn't included and you'd like us to add it in. We <Link to="/methodology">used AI</Link> to extract 
            recommendations from each submission, and to tag them with relevant 
            information. Click on a recommendation to learn more about it.
            See our <a href="https://ifp.org/ai-action-plan/" target="_blank" rel="noopener noreferrer">analysis of common themes and ideas</a> across these recommendations.
          </IntroText>
        </ContentColumn>
      </PageWrapper>
      
      <DatabaseWrapper>
        <AIActionPlanDatabase />
      </DatabaseWrapper>
    </HomeContainer>
  );
}

export default Home; 